import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getAssetPath } from '../utils/assetHelper';
import './WalletTransactionsPage.scss';

// Import jQuery and moment types
import $ from 'jquery';
// Import moment helper to ensure it's globally available
import moment from '../utils/momentHelper';
// Import DataTables
import 'datatables.net';
import 'datatables.net-responsive';
// Import DateRangePicker
import 'daterangepicker';

// Add Bootstrap and DataTables type definitions
declare global {
  interface Window {
    bootstrap: any;
    $: typeof $;
    moment: typeof moment;
  }
}

// Extend jQuery with our plugins
interface JQueryDateRangePicker {
  (options?: any, callback?: any): JQuery;
}

interface JQueryDataTable {
  (options?: any): any;
  isDataTable?: (table: JQuery) => boolean;
}

interface JQueryCustomSelect {
  (options?: any): JQuery;
}

interface JQueryStatic {
  fn: {
    daterangepicker: JQueryDateRangePicker;
    DataTable: JQueryDataTable;
    customSelect: JQueryCustomSelect;
  }
}

interface Transaction {
  id: string;
  date: string;
  type: 'Swap' | 'Buy' | 'In-App' | 'Coupon';
  amount: string;
  currency: string;
  status: 'Success' | 'In process' | 'Failed';
}

const WalletTransactionsPage = () => {
  const tableRef = useRef<HTMLTableElement>(null);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const typeFilterRef = useRef<HTMLSelectElement>(null);
  const [transactions] = useState<Transaction[]>([
    {
      id: '488925',
      date: '16.10.2024, 10:00',
      type: 'Swap',
      amount: '25',
      currency: 'SOL',
      status: 'Success'
    },
    {
      id: '488924',
      date: '16.10.2024, 10:00',
      type: 'Buy',
      amount: '5160',
      currency: '$PHAN',
      status: 'In process'
    },
    {
      id: '488923',
      date: '16.10.2024, 10:00',
      type: 'In-App',
      amount: '8500 XP',
      currency: '',
      status: 'Failed'
    },
    {
      id: '488922',
      date: '16.10.2024, 10:00',
      type: 'Coupon',
      amount: '8500 XP',
      currency: '',
      status: 'Success'
    },
    {
      id: '488921',
      date: '16.10.2024, 10:00',
      type: 'Swap',
      amount: '25',
      currency: 'SOL',
      status: 'Success'
    },
    {
      id: '488920',
      date: '16.10.2024, 10:00',
      type: 'Buy',
      amount: '5160',
      currency: '$PHAN',
      status: 'In process'
    },
    {
      id: '488919',
      date: '16.10.2024, 10:00',
      type: 'In-App',
      amount: '8500 XP',
      currency: '',
      status: 'Failed'
    },
    {
      id: '488918',
      date: '16.10.2024, 10:00',
      type: 'Coupon',
      amount: '8500 XP',
      currency: '',
      status: 'Success'
    },
    {
      id: '488917',
      date: '16.10.2024, 10:00',
      type: 'Swap',
      amount: '25',
      currency: 'SOL',
      status: 'Success'
    },
    {
      id: '488916',
      date: '16.10.2024, 10:00',
      type: 'Buy',
      amount: '5160',
      currency: '$PHAN',
      status: 'In process'
    },
    {
      id: '488915',
      date: '16.10.2024, 10:00',
      type: 'In-App',
      amount: '8500 XP',
      currency: '',
      status: 'Failed'
    },
    {
      id: '488914',
      date: '16.10.2024, 10:00',
      type: 'Coupon',
      amount: '8500 XP',
      currency: '',
      status: 'Success'
    },
    {
      id: '488913',
      date: '16.10.2024, 10:00',
      type: 'Swap',
      amount: '25',
      currency: 'SOL',
      status: 'Success'
    },
    {
      id: '488912',
      date: '16.10.2024, 10:00',
      type: 'Buy',
      amount: '5160',
      currency: '$PHAN',
      status: 'In process'
    },
    {
      id: '488911',
      date: '16.10.2024, 10:00',
      type: 'Buy',
      amount: '5160',
      currency: '$PHAN',
      status: 'In process'
    }
  ]);

  useEffect(() => {
    // Set document title
    document.title = 'Wallet Transactions - Phantom Clash';
    
    // Initialize DataTable if jQuery and DataTables are available
    if ($ && tableRef.current) {
      try {
        // Initialize DataTable
        const table = $(tableRef.current).DataTable({
          paging: true,
          pageLength: 10,
          responsive: false,
          lengthMenu: [10, 25, 50, 100],
          dom: 'rt<"bottom"ipl><"clear">',
          language: {
            lengthMenu: 'Shown: _MENU_',
            info: 'Displayed: <b>_START_-_END_</b>',
            paginate: {
              next: '<i class="bi bi-chevron-right"></i>',
              previous: '<i class="bi bi-chevron-left"></i>',
              first: '',
              last: ''
            }
          }
        });

        // Initialize date range picker
        if (datePickerRef.current) {
          const $datePicker = $(datePickerRef.current);
          
          $datePicker.daterangepicker({
            autoUpdateInput: false,
            opens: "center",
            drops: "auto",
            autoApply: false,
            locale: {
              format: 'YYYY-MM-DD',
              cancelLabel: 'Clear',
            },
          });

          $datePicker.on('apply.daterangepicker', function(this: HTMLElement, ev: any, picker: any) {
            const $this = $(this);
            $this.val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'));
            table.draw();
          });

          $datePicker.on('cancel.daterangepicker', function(this: HTMLElement) {
            const $this = $(this);
            $this.val('');
            table.draw();
          });
        }

        // Initialize type filter
        if (typeFilterRef.current) {
          const $typeFilter = $(typeFilterRef.current);
          
          $typeFilter.on('change', function() {
            table.draw();
          });
        }

        // Add custom search function
        $.fn.dataTable.ext.search.push(
          function(settings: any, data: any) {
            const $datePicker = $(datePickerRef.current!);
            const $typeFilter = $(typeFilterRef.current!);
            
            const dateRange = $datePicker.val() as string || '';
            const type = $typeFilter.val() as string || '';
            const dateColumn = data[1];
            const typeColumn = data[2];

            if (dateRange) {
              const [startStr, endStr] = dateRange.split(' - ');
              const start = moment(startStr, 'YYYY-MM-DD');
              const end = moment(endStr, 'YYYY-MM-DD');
              const rowDate = moment(dateColumn, 'DD.MM.YYYY');
              
              if (!rowDate.isBetween(start, end, null, '[]')) {
                return false;
              }
            }

            if (type && !typeColumn.includes(type)) {
              return false;
            }

            return true;
          }
        );

        // Add custom CSS to match the styling from _component.table.scss
        const customCSS = `
          /* Bottom container styling */
          .bottom {
            display: flex;
            align-items: center;
            margin-top: 25px;
            margin-bottom: 23px;
            justify-content: space-between;
            padding: 0 18px;
          }
          
          /* Info text styling */
          .dataTables_info {
            font-family: 'Manrope', sans-serif;
            font-size: 13px;
            color: var(--gray-900) !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          .dataTables_info b {
            color: var(--white-900) !important;
          }
          
          /* Length selector styling */
          .dataTables_length {
            background-color: #131C2B;
            border-radius: 16px;
            padding: 8px 12px;
            font-family: 'Manrope', sans-serif;
            font-size: 13px;
            color: var(--gray-900) !important;
          }
          
          .dataTables_length select {
            border: 0 !important;
            height: auto;
            background-color: transparent !important;
            padding: 0 !important;
            outline: 0 !important;
            color: var(--white-900) !important;
          }
          
          .dataTables_length select:focus {
            outline: 0 !important;
            border: 0 !important;
          }
          
          /* Pagination container styling */
          .dataTables_paginate {
            display: flex;
            align-items: center;
          }
          
          /* Pagination buttons styling */
          .dataTables_paginate .paginate_button {
            background-color: #131C2B;
            color: var(--gray-900);
            font-family: 'njordregular', sans-serif;
            font-weight: normal;
            font-size: 16px;
            border-radius: 16px;
            height: 36px;
            width: 36px;
            padding: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 0;
            outline: 0;
            transition: all .3s ease;
            margin: 0 4px;
            cursor: pointer;
          }
          
          .dataTables_paginate .paginate_button:hover {
            background-color: var(--white-900);
            color: var(--dark-900);
          }
          
          .dataTables_paginate .paginate_button.current {
            background: linear-gradient(90deg, #0075FF 0%, #00A3FF 100%);
            color: var(--white-900);
          }
          
          .dataTables_paginate .paginate_button.current:hover {
            background-color: initial;
            color: var(--white-900);
          }
          
          .dataTables_paginate .paginate_button.disabled {
            background-color: rgba(19, 28, 43, 0.5);
            color: rgba(var(--gray-900-rgb), 0.5);
            cursor: not-allowed;
          }
          
          .dataTables_paginate .paginate_button.disabled:hover {
            background-color: rgba(19, 28, 43, 0.5);
            color: rgba(var(--gray-900-rgb), 0.5);
          }
          
          .dataTables_paginate .ellipsis {
            font-size: 25px;
            margin: 0 5px;
            color: rgba(var(--gray-900-rgb), 0.5);
          }
          
          /* Media query for mobile */
          @media (max-width: 768px) {
            .dataTables_wrapper .bottom {
              flex-direction: column;
              padding: 0;
              margin-top: 15px;
            }
            
            .dataTables_wrapper .dataTables_info {
              margin-bottom: 15px !important;
            }
            
            .dataTables_wrapper .dataTables_paginate {
              margin-bottom: 18px;
              order: -1;
            }
            
            .dataTables_wrapper .paginate_button {
              width: 32px;
              height: 32px;
              font-size: 14px;
              margin: 0 3px;
            }
            
            .dataTables_wrapper .dataTables_paginate .ellipsis {
              margin: 0 3px;
            }
          }
          
          /* Define CSS variables for colors */
          :root {
            --gray-900: rgba(255, 255, 255, 0.7);
            --gray-900-rgb: 255, 255, 255;
            --white-900: #fff;
            --dark-900: #121A2B;
            --primary-900: #6610f2;
          }
        `;

        // Create a style element and append it to the head
        const styleElement = document.createElement('style');
        styleElement.textContent = customCSS;
        document.head.appendChild(styleElement);
        
      } catch (error) {
        console.error('Error initializing components:', error);
      }
    }

    // Cleanup function
    return () => {
      if ($ && tableRef.current) {
        try {
          const $table = $(tableRef.current);
          try {
            const dt = $table.DataTable();
            if (dt) {
              dt.destroy();
            }
          } catch (e) {
            console.error('Error destroying DataTable:', e);
          }
        } catch (error) {
          console.error('Error in cleanup:', error);
        }
      }
    };
  }, []);

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'Swap':
        return 'bi-lightning-charge';
      case 'Buy':
        return 'bi-credit-card';
      case 'In-App':
        return 'bi-cart2';
      case 'Coupon':
        return 'bi-sticky';
      default:
        return 'bi-list-ul';
    }
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Success':
        return <span className="c-badge c-badge--success"><i className="bi bi-check-circle-fill"></i> Success</span>;
      case 'In process':
        return <span className="c-badge c-badge--inprocess"><i className="bi bi-clock-fill"></i> In process</span>;
      case 'Failed':
        return <span className="c-badge c-badge--failed"><i className="bi bi-x-circle-fill"></i> Failed</span>;
      default:
        return <span className="c-badge"><i className="bi bi-question-circle-fill"></i> Unknown</span>;
    }
  };

  return (
    <div className="wallet-transactions">
      {/* Page Menu - Exactly matching the original HTML structure */}
      <div className="c-page-menu">
        <ul>
          <li><Link to="/wallet-finance">Finance</Link></li>
          <li className="active"><Link to="/wallet-transactions">Transactions</Link></li>
          <li><Link to="/wallet-security">Security Settings <span></span></Link></li>
        </ul>
      </div>

      <div className="d-block w-100">
        {/* Section Title - Exactly matching the original HTML structure */}
        <div className="c-section-title mt-0">
          <div className="d-flex flex-column justify-content-center">
            <h1>
              <img src={getAssetPath("assets/images/wallet-overview.svg")} alt="" />
              Transaction History
            </h1>
            <p className="c-section-title__desc">View your recent transactions and activity</p>
          </div>
          <div className="p-wallet-overview__actions d-flex ms-lg-auto ms-0 align-self-lg-end">
            <div className="c-datepicker me-2" id="dateRangePicker" ref={datePickerRef}>Date</div>
            <select id="typeFilter" className="c-selectbox" style={{ width: '150px' }} ref={typeFilterRef}>
              <option value="" data-icon="<i class='bi bi-list-ul'></i>">All Types</option>
              <option value="Swap" data-icon="<i class='bi bi-lightning-charge'></i>">Swap</option>
              <option value="Buy" data-icon="<i class='bi bi-credit-card'></i>">Buy</option>
              <option value="In-App" data-icon="<i class='bi bi-cart2'></i>">In-App</option>
              <option value="Coupon" data-icon="<i class='bi bi-sticky'></i>">Coupon</option>
            </select>
          </div>
        </div>

        {/* Transactions Table - Exactly matching the original HTML structure */}
        <div className="box d-block">
          <table id="transactionsTable" className="c-table nowrap" style={{ width: '100%' }} ref={tableRef}>
            <thead>
              <tr>
                <th data-priority="1">ID</th>
                <th>Date</th>
                <th data-priority="3">Type</th>
                <th data-priority="2">Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction) => (
                <tr key={transaction.id}>
                  <td>
                    <b><small>#</small> {transaction.id}</b>
                  </td>
                  <td>{transaction.date}</td>
                  <td>
                    <div className={`type ${transaction.type.toLowerCase()}`}>
                      <i className={`bi ${getTypeIcon(transaction.type)}`}></i> {transaction.type}
                    </div>
                  </td>
                  <td>
                    <span>
                      {transaction.amount} {transaction.currency && <b>{transaction.currency}</b>}
                    </span>
                  </td>
                  <td>
                    {getStatusBadge(transaction.status)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WalletTransactionsPage; 